module.exports = __webpack_public_path__ + "img/Weapon_179.0dfe517d.png";